export default __webpack_public_path__ + "static/Presentacion3-05aea5ebac71a11d49a85d6d525b7653.pdf";